import { useQuery } from '@tanstack/react-query';
import { THIRTY_MINUTES_MS } from '@izimi/utils';
import StudyQueryKeys from './StudyQueryKeys';
const studyQueryKeys = new StudyQueryKeys();
const createStudyModule = ({ studyApi }) => {
    const useGetStudy = ({ studyId }) => {
        const { data, isLoading, error, isSuccess } = useQuery({
            queryKey: studyQueryKeys.getStudy(studyId),
            queryFn: () => studyApi.getStudy(studyId),
            staleTime: THIRTY_MINUTES_MS,
            refetchOnWindowFocus: false,
        });
        return {
            study: data,
            error,
            isLoading,
            isSuccess,
        };
    };
    return {
        useGetStudy,
    };
};
export default createStudyModule;
